import axiosInstance from "../services/axiosInstance";

export const register = async (payload) => {
  try {
    const response = await axiosInstance.post("../auth/register", payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
